<template>
  <router-view/>
</template>

<style>
html, body, #app {
  width: 100%;
  height: 100%;
  margin: 0; /* 去除默认的margin */
  padding: 0; /* 去除默认的padding */
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
